import {
	type GetMyMultiFactorStatusQuery,
	type GetTenantMultiFactorPolicyQuery
} from "~/gql/queries/multiFactor.generated";

export const multiFactorEndpoints = {
	CompleteMyMultiFactorEnrollment: {
		invalidatesTags: ["MultiFactor"] as AddTagTypes
	},
	DisableMyMultiFactor: {
		invalidatesTags: ["MultiFactor"] as AddTagTypes
	},
	GetMyMultiFactorRecoveryCodes: {
		keepUnusedDataFor: 0
	},
	GetMyMultiFactorStatus: {
		providesTags: ["MultiFactor"] as AddTagTypes,
		transformResponse: (res: GetMyMultiFactorStatusQuery) => res
	},
	GetTenantMultiFactorPolicy: {
		providesTags: ["TenantMultiFactorPolicy"] as AddTagTypes,
		transformResponse: (res: GetTenantMultiFactorPolicyQuery) => res
	},
	RegenerateMyMultiFactorRecoveryCodes: {
		invalidatesTags: ["MultiFactor"] as AddTagTypes
	},
	SetTenantMultiFactorRequirement: {
		invalidatesTags: ["TenantMultiFactorPolicy"] as AddTagTypes
	}
};
